import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectAuth } from '@app/features/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

import { getDefaultNavigationUrl } from './first-allowed-context.guard';

type AccessServicePageKind = 'forbidden' | 'access-unavailable';

export function getAccessServicePageGuard(
  kind: AccessServicePageKind,
): CanActivateFn {
  return () => {
    const router = inject(Router);

    return inject(Store)
      .select(selectAuth)
      .pipe(
        filter(
          (auth) =>
            auth.init &&
            !auth.sessionTransitioning &&
            (auth.accessStatus === 'ready' || auth.accessStatus === 'failed'),
        ),
        take(1),
        map((auth) => {
          if (kind === 'forbidden') {
            return auth.accessStatus === 'failed'
              ? router.parseUrl('/access-unavailable')
              : true;
          }

          return auth.accessStatus === 'failed'
            ? true
            : router.parseUrl(getDefaultNavigationUrl(auth.access));
        }),
      );
  };
}

export const forbiddenServicePageGuard = getAccessServicePageGuard('forbidden');
export const accessUnavailableServicePageGuard =
  getAccessServicePageGuard('access-unavailable');
